import { FC, useEffect, useState } from 'react'
import { useFinishSignup } from '../hooks/useFinishSignup'
import HCaptcha from '@hcaptcha/react-hcaptcha'
import { usePostApiV1AccountsCheckCaptchaMutation } from '../../../authApi'
import { useSignUpHash } from '../hooks/useSignUpHash'
import { useSelector } from 'react-redux'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import { SignUpStages } from '../SignUpStages'
import { ButtonLoader } from '@wellesley/ui'

export const ReCaptcha: FC = () => {
  const captcha = useSelector(platformSettingsSlice.selectors.selectCaptcha)

  const hash = useSignUpHash()
  const [captchaToken, setCaptchaToken] = useState<string>()

  const [checkCaptcha, { isSuccess, data, isLoading }] =
    usePostApiV1AccountsCheckCaptchaMutation()
  const handleContinue = () => {
    hash &&
      captchaToken &&
      void checkCaptcha({ captchaVerificationParams: { hash, captchaToken } })
  }

  const { finishSignup } = useFinishSignup()
  useEffect(() => {
    isSuccess && data && void finishSignup(data)
  }, [isSuccess, finishSignup, data?.hash])

  return (
    <div className="flex w-auto flex-col items-center">
      <SignUpStages position={3} />
      <div className="my-m flex flex-col items-center">
        <div className="flex flex-col items-center pt-m">
          <h1 className="text-lg  font-semibold text-gray-900">Antispam</h1>
          <p className="mb-s mt-xxs text-base font-medium text-gray-500">
            We need to confirm you&apos;re a human
          </p>
        </div>
        <HCaptcha sitekey={captcha?.siteKey ?? ''} onVerify={setCaptchaToken} />
      </div>
      <div className="mt-s flex w-[450px] justify-end py-s">
        <ButtonLoader
          variant="primary"
          size="m"
          disabled={!captchaToken}
          isLoading={isLoading}
          onClick={handleContinue}
        >
          Continue
        </ButtonLoader>
      </div>
    </div>
  )
}
